import request from '@/utils/request'

export const authApi = {
  // 用户登录
  login(data) {
    return request({
      url: '/inventory-management-api/account/login',
      method: 'POST',
      data
    })
  }
}